import React from 'react'
import ReactDOM from 'react-dom'
import Main from './main_container.js'
import { BrowserRouter, Route } from 'react-router-dom'
import { Provider } from "react-redux"
import { applyMiddleware, createStore } from 'redux'
import thunk from 'redux-thunk'
import rootReducer from './reducers/root_reducer.js'
import '../../i18n'

let store = createStore(
  rootReducer,
  applyMiddleware(thunk)
)

const render = (props) => {
  const isMap = /view=map/.test(props.location.search)
  if (isMap) {
    return <Main {...props} />
  } else {
    return <Main key={props.location.search} {...props} />
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('.crust')
  ReactDOM.render(
    <BrowserRouter>
      <Provider store={store}>
        <React.Fragment>
          <Route path='/:locale?/s/:prefecture/:city?/:spot_id?' render={render} />
          <Route path='/:locale?/country/:country/search' render={render} />
          <Route path='/:locale?/search' render={render} />
        </React.Fragment>
      </Provider>
    </BrowserRouter>,
    root
  )
})
